import { render, staticRenderFns } from "./CardEnvio.vue?vue&type=template&id=70d1e02e"
import script from "./CardEnvio.vue?vue&type=script&setup=true&lang=js"
export * from "./CardEnvio.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports